module.exports = __webpack_public_path__ + "img/img42.72ee9502.svg";